module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "ch4-wetland--cover.611a718d.jpeg";